import {getDate} from '../../../../../../@casino/lib/getDate';

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'event_date', label: 'Дата'},
    { id: 'recipient', label: 'Получатель'},
    { id: 'amount', label: 'Сумма'},
    { id: 'balance', label: 'Баланс до'},
];

const getRows = (data) => {
    return data.map((item) => {
        return {
            id: item.id,
            event_date: getDate(item.event_date),
            recipient: item.group_name,
            amount: new Intl.NumberFormat('ru-RU').format(item.amount) + ' ₽',
            balance: new Intl.NumberFormat('ru-RU').format(item.balance) + ' ₽',
        }
    })
} 

export {
    columns,
    getRows
}